'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { ComingSoonPolicyCard, PolicySectionHeader } from '@/features/identity-policy';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/access-rules/')({
  component: AccessRulesPage
});
function AccessRulesPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.settings.authentication.accessRules'
  });
  return <VStack className="w-full gap-4 px-12 py-6">
      <PolicySectionHeader iconName="ShieldIcon" title={t('title')} description={t('description')} />
      <ComingSoonPolicyCard />
    </VStack>;
}